module.exports = __webpack_public_path__ + "static/media/details-21-image-3.fbc9c87a.jpg";